import React, {Component} from 'react';
import {GeckoModal} from "@geckolabs/gecko-react-ui";
import {buildModalButtons} from "../../../../../../Logic/ImportExport";

export default class AddToQueue extends Component {
    constructor(props) {
        super();
        this.action = 'addToQueue';

        this.state = {
            id: props.id,
            type: props.type,
            accountId: props.account_id,
            name: 'Add ' + props.type + ' to queue',
        };
    }

    render() {
        return (
            <GeckoModal name={this.state.name} btns={buildModalButtons(this.state, this.action)}>
                <div className="text-center">
                    Are you sure you want to add {this.state.type} <span className="font-weight-bold">{this.state.id}</span> to queue?
                </div>
            </GeckoModal>
        );
    }
}
